module.exports = __webpack_public_path__ + "img/NL1154291.a8172e7a.png";